module.exports = __webpack_public_path__ + "static/media/approval.2eca0988.svg";